import React from 'react';
import { CollapsibleContainerHeader as Component, } from '@vfuk/core-collapsible-container';
const CollapsibleContainerHeader = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CollapsibleContainerHeader;
